export default class UserVendorViewAPIRequest {
  public asVendor: boolean;

  public constructor(asVendor: boolean) {
    this.asVendor = asVendor;
  }
}
